import { Breadcrumb,  } from 'antd'
import { Link, useParams } from 'react-router-dom'
import EsignAccordion from './EsignAccordion';

export default function EsignListitemDetails() {
    const { id } = useParams();

    return (
        <>
            <div className="sticky -top-6 bg-white dark:bg-[#17153B] z-10 shadow-sm p-4">
                <Breadcrumb className="text-lg font-medium text-gray-700">
                    <Breadcrumb.Item>
                        <Link to="/admin/esign" className="hover:text-blue-600 transition-colors">
                            Esign
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className="text-blue-500 font-semibold"> Esign Details</Breadcrumb.Item>
                </Breadcrumb>
            </div>
                <EsignAccordion id={id}/>
        </>
    )
}
